import type { PropsWithChildren, ReactNode } from 'react'

export function SectionTitle({
  title,
  eyebrow,
  children,
}: PropsWithChildren<{ title: string; eyebrow?: string; children?: ReactNode }>) {
  return (
    <div className="section-title">
      {eyebrow ? <p className="section-title__eyebrow">{eyebrow}</p> : null}
      <div className="section-title__row">
        <div>
          <h2>{title}</h2>
        </div>
        {children}
      </div>
    </div>
  )
}
